export enum AccountType {
  Regular = 'Regular',
  Rented = 'Rented',
  Purchased = 'Purchased',
  Degressive = 'Degressive',
}
